module.exports = __webpack_public_path__ + "static/media/us.7ca631d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/us.jpg
// module id = 277
// module chunks = 0